import { TokenManager } from "namirasoft-account";
import { EnvService, FilterItem, FilterItemOperator, IStorageSession, SortItem } from "namirasoft-core";
import { NamirasoftMap } from "namirasoft-site-map";
import { DateTimeFormatter, NSBoxBoolean, NSBoxTextArea, NSButtonBlue, NSLabel, NSLoading, NSPanel, NSRow, NSSpace, NSSpaceSizeType, StringFormatter } from "namirasoft-site-react";
import { MessageInputRow, MessageRow, NamirasoftSupportServer, TicketRow, TicketStatus } from "namirasoft-support";
import { createRef, useEffect, useState } from "react";
import Styles from "../pages/TicketViewPage.module.css";

export interface TicketMessagesProps
{
    row: TicketRow;
}

export interface TicketMessagesState
{
    messages: MessageRow[];
    isLoading: boolean;
    isResolvedChecked: boolean;
}

function buildContext()
{
    let token_manager = new TokenManager(new IStorageSession(), () => { });
    let base_url = new EnvService("REACT_APP_BASE_URL_SUPPORT", true).getString();
    return {
        namirasoft: new NamirasoftMap(token_manager, console.error),
        support: new NamirasoftSupportServer(base_url, token_manager, console.error),
    };
}

export default function TicketMessages(props: TicketMessagesProps)
{
    const [state, setState] = useState<TicketMessagesState>({ messages: [], isLoading: true, isResolvedChecked: false });

    let NSBoxTextArea_Message = createRef<NSBoxTextArea>();
    let NSBoxBoolean_TicketResolved = createRef<NSBoxBoolean>();

    useEffect(() =>
    {
        if (!props.row.id)
            return;

        setState((prev) => ({ ...prev, isLoading: true }));

        let { namirasoft, support } = buildContext();
        let filter_item = new FilterItem(
            namirasoft.support.tables.message,
            namirasoft.support.tables.message.columns.ticket_id,
            false,
            FilterItemOperator.all.equals,
            props.row.id
        );
        let sort_item = new SortItem(
            namirasoft.support.tables.message,
            namirasoft.support.tables.message.columns.created_at,
            true,
        );

        support.message.List([filter_item], 1, 100, [sort_item], null)
            .then((response) => setState((prev) => ({ ...prev, messages: response.rows, isLoading: false })))
            .catch(() => setState((prev) => ({ ...prev, isLoading: false })));
        // eslint-disable-next-line
    }, [props.row.id]);

    const sendMessage = () =>
    {
        try
        {
            let ticket = props.row;
            let message = NSBoxTextArea_Message.current?.getValue() ?? "";
            let ticket_resolved = NSBoxBoolean_TicketResolved.current?.getValue() ?? false;

            let message_payload: MessageInputRow = {
                message,
                ticket_resolved,
                sender_id: ticket.user_id,
                ticket_id: ticket.id
            }

            let is_current_ticket_resolved = ticket.status === TicketStatus.Resolved;

            let { support } = buildContext();

            support.message.Create(message_payload)
                .then(res =>
                {
                    if (is_current_ticket_resolved !== message_payload.ticket_resolved)
                        window.location.reload();
                    else
                    {
                        setState((prev) => ({ ...prev, messages: [...prev.messages, res] }));
                        NSBoxTextArea_Message.current?.setValue(null);
                    }
                }).catch(() => { });
        } catch (e) { }
    }

    return (
        <>
            <NSSpace size={NSSpaceSizeType.MEDUIM}></NSSpace>
            <NSPanel style={{ width: "100%", maxWidth: "50rem", margin: "0 auto", alignItems: "flex-start" }}>
                {
                    state.isLoading
                        ? <NSLoading title="Loading Namirasoft Ticket messages ..." style={{ width: "100%" }} />
                        : state.messages.map((row) => (
                            <NSLabel
                                key={row.id}
                                title={row.sender_id === row.user_id ? "Me" : "Namirasoft Support Team"}
                                description={new DateTimeFormatter().format(row.created_at)}
                                classList={[Styles.ns_message]}
                            >
                                <p>{StringFormatter.toHTML(row.message)}</p>
                            </NSLabel>
                        ))
                }

                <NSBoxTextArea
                    ref={NSBoxTextArea_Message}
                    required={true}
                    title="Message"
                    style={{ width: "100%", marginTop: "1rem" }}
                />
                <NSRow>
                    <NSBoxBoolean
                        ref={NSBoxBoolean_TicketResolved}
                        required={false}
                        title="Resolved"
                        hideHeader
                        defaultValue={props.row.status === TicketStatus.Resolved}
                        onChanged={(box) =>
                        {
                            setState((prev) => ({
                                ...prev,
                                isResolvedChecked: box.getValue() ?? false
                            }));
                        }}
                    />
                    <NSButtonBlue
                        title={
                            props.row.status !== TicketStatus.Resolved ||
                                state.isResolvedChecked
                                ? "Send"
                                : "Reopen"
                        }
                        onClick={{ action: () => sendMessage(), showLoading: false }}
                    />
                </NSRow>
            </NSPanel>
        </>
    );
}